export default __webpack_public_path__ + "static/media/_DSC0320.36d7e93a.JPG";